import React from 'react';
import type { PackageStatus } from '../../types/disclosures';
export type PillTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger';
const toneClasses: Record<PillTone, string> = {
  neutral: 'bg-slate-100 text-slate-600 ring-slate-200',
  info: 'bg-blue-50 text-blue-700 ring-blue-200',
  success: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  warning: 'bg-amber-50 text-amber-700 ring-amber-200',
  danger: 'bg-red-50 text-red-700 ring-red-200'
};
interface StatusPillProps {
  tone?: PillTone;
  children: React.ReactNode;
  className?: string;
}
export function StatusPill({
  tone = 'neutral',
  children,
  className = ''
}: StatusPillProps) {
  return <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset ${toneClasses[tone]} ${className}`} data-id="element-400" data-mp="egl70l0hc58k">
      {children}
    </span>;
}
const statusMeta: Record<PackageStatus, {
  label: string;
  tone: PillTone;
}> = {
  not_generated: {
    label: 'Not Generated',
    tone: 'neutral'
  },
  preparing: {
    label: 'Preparing',
    tone: 'info'
  },
  ready: {
    label: 'Ready to Send',
    tone: 'success'
  },
  sent: {
    label: 'Sent',
    tone: 'success'
  },
  action_required: {
    label: 'Action Required',
    tone: 'warning'
  }
};
export function PackageStatusPill({
  status
}: {
  status: PackageStatus;
}) {
  const meta = statusMeta[status];
  return <StatusPill tone={meta.tone} data-id="element-401" data-mp="osqy1knsjyop">
      {status === 'preparing' && <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-blue-500" aria-hidden="true" data-id="element-402" data-mp="tpr6g2845diz" />}
      {meta.label}
    </StatusPill>;
}